import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import ListingCard from '@/components/ListingCard';
import { Button } from '@/components/ui/button';
import { Sparkles, Settings2, Info } from 'lucide-react';
import MatchExplain from '@/components/MatchExplain';
import Mascot from '@/components/Mascot';

export default function Suggested() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasPrefs, setHasPrefs] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const me = await api.get('/auth/me');
        const prefs = me.data?.preferences || {};
        setHasPrefs(Object.keys(prefs).length > 0);
        const { data } = await api.get('/matches');
        setItems(data || []);
      } catch {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Suggeriti per te</div>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Terreni compatibili con la tua ricerca.</h1>
          <p className="mt-3 text-muted-foreground max-w-xl">Il punteggio è calcolato da regole trasparenti. Ogni fattore che contribuisce è indicato con + o − sotto ogni scheda.</p>
        </div>
        <Link to="/preferenze"><Button variant="outline" className="rounded-full"><Settings2 size={14} className="mr-2"/> Modifica preferenze</Button></Link>
      </div>

      {!hasPrefs && (
        <div className="rounded-2xl border border-dashed border-border p-10 mb-8 flex items-center gap-4">
          <Info size={22} className="text-muted-foreground"/>
          <div>
            <div className="font-medium">Non hai ancora impostato preferenze.</div>
            <div className="text-sm text-muted-foreground">Imposta cosa stai cercando per vedere terreni ordinati per compatibilità.</div>
          </div>
          <Link to="/preferenze" className="ml-auto"><Button className="rounded-full">Imposta ora</Button></Link>
        </div>
      )}

      {loading ? <div className="text-sm text-muted-foreground">Caricamento…</div> :
        items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-border p-16 text-center">
            <div className="flex justify-center">
              <Mascot pose="search" size={160}/>
            </div>
            <h3 className="mt-6 font-display text-2xl">Giulio sta cercando per te.</h3>
            <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">Non ci sono ancora terreni compatibili. Appena un nuovo annuncio matcha le tue preferenze, lo troverai qui.</p>
            <Link to="/preferenze" className="inline-block mt-6">
              <Button variant="outline" className="rounded-full"><Settings2 size={14} className="mr-2"/> Perfeziona le preferenze</Button>
            </Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(l => (
              <div key={l.listing_id}>
                <ListingCard listing={l} showMatch/>
                {l.match_reasons?.length > 0 && (
                  <ul className="mt-3 text-xs space-y-1">
                    {l.match_reasons.slice(0,5).map((r,i) => {
                      const isPlus = r.startsWith('+');
                      const isMinus = r.startsWith('-');
                      return (
                        <li key={i} className={`${isPlus?'text-foreground':isMinus?'text-destructive':'text-muted-foreground'}`}>
                          {r}
                        </li>
                      );
                    })}
                  </ul>
                )}
                <MatchExplain listingId={l.listing_id}/>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
